





import {apiV1AdminNewJobPath, apiV1AdminNewJobsPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class NewJobsNew extends PostNew {
  path = 'new_jobs'
  createPath = apiV1AdminNewJobsPath()

  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminNewJobPath('new')
    return super.mounted()
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '新着求人',
        to: '/admin/new_jobs',
        exact: true
      },
      {
        text: '新着求人新規作成'
      }
    ]
  }
}
